import React, { useState } from 'react';
import { Dropdown, Menu } from 'antd';
import Btn from './Btn';
import { useOnActionClick } from '../hooks/useOnActionClick';

const DropdownOverlay = ({ printForms, onMenuClick, ...props }) => {
  return (
    <Menu
      {...props}
      onClick={onMenuClick}
    >
      {printForms.map((form) => (
        <Menu.Item
          key={form.id}
          form={form}
        >
          {form.name}
        </Menu.Item>
      ))}
    </Menu>
  );
};

const PrintMultipleForms = ({ printForms, actionStyle, requestIds }) => {
  const [visible, setVisible] = useState(false);
  const { loading, onActionClick } = useOnActionClick(requestIds);

  const handleVisibleChange = (visible) => setVisible(visible);

  const handleMenuClick = ({ item }) => {
    const form = item.props.form;
    onActionClick(form);
    setVisible(false);
  };

  return (
    <Dropdown
      trigger={['click']}
      visible={visible}
      onVisibleChange={handleVisibleChange}
      overlay={
        <DropdownOverlay
          printForms={printForms}
          onMenuClick={handleMenuClick}
        />
      }
    >
      <Btn
        loading={loading}
        style={actionStyle}
        tooltipTitle={visible ? '' : 'Печатные формы'}
      />
    </Dropdown>
  );
};

export default PrintMultipleForms;
